export const CHECK_AVAILABILITY_LABEL = "Check availability";
